<div class="steps-wrap" [attr.data-count]="steps.length">
  <div *ngFor="let step of steps; let i = index" class="step" [class.active]="step.active" [class.next]="isNextStep(i)">
    <div class="step-text">{{ step.text }}</div>
    <div class="arrow"></div>
  </div>
</div>
